var styles = {"row":"styles_row__LvrZ1","sent":"styles_sent__NP84S","status":"styles_status__1Enkc","flat":"styles_flat__15Erh"};

export default styles;
//# sourceMappingURL=styles.css.js.map
